// Shared postal-code range logic, used by the bulk-create range tab (ZipRangeMode)
// and the single-create form's "Rango de CP" tab. Keeping it in one place means
// both flows validate and expand ranges identically.

export const MAX_RANGE = 5000

const isDigits = (s) => /^\d+$/.test(s)

/**
 * Validate a start–end postal-code range.
 * Returns { valid, reason, count } and, when valid, { len, s, e } too.
 *   reason ∈ "same-length-digits" | "start-after-end" | "too-large" (or null).
 */
export const computeRange = ({ start, end }) => {
  if (!start || !end) return { valid: false, reason: null, count: 0 }
  if (!isDigits(start) || !isDigits(end) || start.length !== end.length) {
    return { valid: false, reason: "same-length-digits", count: 0 }
  }
  const s = parseInt(start, 10)
  const e = parseInt(end, 10)
  if (s > e) return { valid: false, reason: "start-after-end", count: 0 }
  const count = e - s + 1
  if (count > MAX_RANGE) return { valid: false, reason: "too-large", count }
  return { valid: true, count, len: start.length, s, e }
}

/** Expand a *valid* range into its zero-padded postal-code strings. */
export const expandRangeValues = (range) => {
  const values = []
  for (let n = range.s; n <= range.e; n++) {
    values.push(String(n).padStart(range.len, "0"))
  }
  return values
}
